const blue500Color = '#57648d';

export default blue500Color;
